// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components
import SoftwareCard from "./SoftwareCard"

// Data / Images / Icons
import { SOFTWARE_PROJECTS } from "src/data/pages/softwares"

function SoftwareCardGroup() {
  return (
    <div className="">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {SOFTWARE_PROJECTS.map((project, index) => (
        <SoftwareCard key={index} project={project} />
      ))}
    </div>
  </div>
  )
}

export default SoftwareCardGroup